import React from 'react';
import { createLazyPage } from '../createLazyPage';
import { AppRouteDefinition } from '../routeDefinition';

const AclAdminPage = createLazyPage(
  () => import('@app/modules/aclAdmin/pages/AclAdminPage')
);

export const aclRoutes: AppRouteDefinition[] = [
  {
    key: 'acl-admin',
    path: 'acl-admin',
    element: <AclAdminPage />,
  },
];
